import { Spin } from "antd";
import { useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import LoadMore from "../components/LoadMore";
import commonStyles from "../components/nodeTypeComponents.module.css";
import styles from "./Shopping.module.css";
import ShoppingDetail from "./ShoppingDetail";
import { defaultAdapter } from "./shoppingItemAdapter";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import useFocusNode from "@custom-hooks/useFocusNode";
import useEnableScroll from "../../../../custom-hooks/useEnableScroll";
import { NO_WHEEL } from "../constants";

const Shopping = props => {
  const scrollBoxRef = useRef(null);
  const disableAddPreview = useSelector(state => state.fot.disableAddPreview);

  const { enableScroll, mouseEnterLeave } = useEnableScroll();

  const {
    id,
    initialReportSize,
    content = {},
    resizeEventParams = {},
    useShopping,
    shoppingItem: ShoppingItem,
    adapter = defaultAdapter,
    isTargetNode,
    checkNodeArr = [],
  } = props;

  const firstPageDate = useMemo(() => {
    let result = content || {};
    if (typeof content === "string") {
      try {
        result = JSON.parse(content);
      } catch (error) {
        console.log(error);
      }
    }
    return result;
  }, [content]);

  const { list, loading, noMore, keywords, getNewData, getLoadMoreData, setKeywords } = useShopping(firstPageDate);

  const [modeElement, setModeElement] = useState(null);

  const { height = initialReportSize.height, width = initialReportSize.width } = resizeEventParams;

  const { focusNodeTopBarById } = useFocusNode();

  const handleChangeSearch = e => {
    setKeywords(e.target.value);
  };

  const handleKeyDown = async event => {
    if (event.key === "Enter") {
      await getNewData();
      scrollBoxRef.current.scrollTop = 0;
    }
  };

  const handleClickLoadMore = async () => {
    getLoadMoreData();
  };

  const handleClickShowDetail = shoppingInfo => {
    setModeElement(<ShoppingDetail shoppingInfo={adapter(shoppingInfo)} onClick={handleClickHideDetail} />);
  };

  const handleClickHideDetail = () => {
    setModeElement(null);
  };

  const noWheelClassName = checkNodeArr?.includes(props.id) && enableScroll ? NO_WHEEL : "";

  return (
    <div className={`${commonStyles.scrollContent} ${styles.scrollContent} ${isTargetNode ? styles["target"] : ""}`}>
      <div className={`${styles.inner} ${isTargetNode ? styles["target-inner"] : ""}`}>
        {modeElement}
        <div className={styles.searchBar}>
          <div className={styles["img-box"]}>
            <img src={`${settings.S3CDN}${settings.viewAssetsPath}search.svg`} alt="" />
          </div>
          <input
            type="text"
            placeholder="Search"
            value={keywords}
            onFocus={() => {
              focusNodeTopBarById(id);
            }}
            onChange={handleChangeSearch}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className={styles.title}>Featured</div>
        <Spin spinning={loading}>
          <div
            ref={scrollBoxRef}
            className={`${commonStyles.scrollList} ${styles.scrollList} ${noWheelClassName}`}
            style={{ height: height - 140, paddingBottom: disableAddPreview ? 0 : 60 }}
            onMouseEnter={() => mouseEnterLeave(true)}
            onMouseLeave={() => mouseEnterLeave(false)}
          >
            {list.map((shoppingItemInfo, index) => {
              return (
                <ShoppingItem
                  key={`${shoppingItemInfo.title}${index}`}
                  onClick={handleClickShowDetail}
                  shoppingItemInfo={shoppingItemInfo}
                />
              );
            })}

            <LoadMore onClick={handleClickLoadMore} loading={loading} noMore={noMore} />
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default Shopping;
